// import { UserRoleByIDAPI } from "api";
// import { createContext, useContext, useEffect, useState } from "react";

// const PermissionContext = createContext(null);

// export const PermissionProvider = ({ children }) => {
//   const [permissions, setPermissions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [roleId, setRoleId] = useState(() => {
//     const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
//     return userInfo?.role ?? 0;
//   });

//   useEffect(() => {
//     const handleStorageChange = () => {
//       const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
//       setRoleId(userInfo?.role ?? 0);
//     };

//     window.addEventListener("storage", handleStorageChange);

//     return () => {
//       window.removeEventListener("storage", handleStorageChange);
//     };
//   }, []);

//   useEffect(() => {
//     if (!roleId) {
//       setLoading(false);
//       return;
//     }

//     async function fetchPermission() {
//       try {
//         const response = await UserRoleByIDAPI.get({ params: { roleId } });
//         setPermissions(response?.data?.data?.permissions || []);
//       } catch (error) {
//         console.error("Error fetching permissions:", error);
//       } finally {
//         setLoading(false);
//       }
//     }

//     fetchPermission();
//   }, [roleId]);

//   // console.log("permissions", permissions);

//   const hasPermission = (menuId, type) => {
//     return permissions?.some((p) => p.menuId == menuId && p[type]);
//   };

//   return (
//     <PermissionContext.Provider value={{ permissions, hasPermission, loading }}>
//       {children}
//     </PermissionContext.Provider>
//   );
// };

// export const usePermission = () => {
//   const context = useContext(PermissionContext);
//   if (!context) {
//     throw new Error("usePermission must be used within PermissionProvider");
//   }
//   return context;
// };

import { UserRoleByIDAPI } from "api";
import { createContext, useContext, useEffect, useState } from "react";

const PermissionContext = createContext(null);

export const PermissionProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [roleId, setRoleId] = useState(() => {
    const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
    return userInfo?.role ?? 0;
  });

  const [userType, setUserType] = useState(() => {
    const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
    return userInfo?.type || "";
  });

  // useEffect(() => {
  //   const handleStorageChange = () => {
  //     const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
  //     setRoleId(userInfo?.role ?? 0);
  //   };

  //   window.addEventListener("storage", handleStorageChange);

  //   return () => {
  //     window.removeEventListener("storage", handleStorageChange);
  //   };
  // }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
      setRoleId(userInfo?.role ?? 0);
      setUserType(userInfo?.type || "");
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    if (!roleId) {
      setLoading(false);
      return;
    }

    async function fetchPermission() {
      try {
        const response = await UserRoleByIDAPI.get({ params: { roleId } });
        setPermissions(response?.data?.data?.permissions || []);
      } catch (error) {
        console.error("Error fetching permissions:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchPermission();
  }, [roleId]);

  // console.log("permissions", permissions);

  // const hasPermission = (menuId, type) => {
  //   return permissions?.some((p) => p.menuId == menuId && p[type]);
  // };
  // const hasPermissionByName = (name, type) => {
  //   return permissions?.some((p) => p.menuName == name && p[type]);
  // };

  const hasPermission = (menuId, type) => {
    if (userType === "Admin") return true; // 🔥 bypass
    return permissions?.some((p) => p.menuId == menuId && p[type]);
  };

  const hasPermissionByName = (name, type) => {
    if (userType === "Admin") return true; // 🔥 bypass
    return permissions?.some((p) => p.menuName == name && p[type]);
  };

  return (
    <PermissionContext.Provider
      value={{ permissions, hasPermission, hasPermissionByName, loading }}
    >
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermission = () => {
  const context = useContext(PermissionContext);
  if (!context) {
    throw new Error("usePermission must be used within PermissionProvider");
  }
  return context;
};
